import type { HistoryData, HistoryLength } from "@/API";
import type { State } from "@/types/common";
import { create } from "zustand";
import { generateClient, type GraphQLResult } from "aws-amplify/api";
import { getRestaurantCharts as getRestaurantChartsQuery } from "@/graphql/queries";
import type { GraphQLError } from "graphql";

const client = generateClient();

export const restaurantChartsState = create<State<HistoryData>>(() => ({
  data: null,
  isLoading: false,
  error: null,
  isFetching: false,
}));

export const getRestaurantChartsIsloading = () =>
  restaurantChartsState.setState(() => ({
    isLoading: true,
    data: null,
    error: null,
  }));
export const getRestaurantChartsIsError = (error: GraphQLError[]) =>
  restaurantChartsState.setState(() => ({
    error: error,
    data: null,
    isLoading: false,
  }));
export const getRestaurantChartsIsSuccess = (historyData: HistoryData) =>
  restaurantChartsState.setState(() => ({
    data: historyData,
    isLoading: false,
    error: null,
  }));

export type GetRestaurantChartsParams = {
  restaurantId: string;
  length: HistoryLength;
};

export const getRestaurantCharts = async ({
  restaurantId,
  length,
}: GetRestaurantChartsParams) => {
  getRestaurantChartsIsloading();

  try {
    const { data } = await client.graphql({
      query: getRestaurantChartsQuery,
      variables: {
        id: restaurantId,
        length: length,
      },
    });

    getRestaurantChartsIsSuccess(data.getRestaurantCharts as HistoryData);
  } catch (e: unknown) {
    const graphQl = e as GraphQLResult<HistoryData>;
    getRestaurantChartsIsError(graphQl.errors as GraphQLError[]);
  }
};
